<template>
<div>
  <v-card>
    <TradeRequestFinalizeForm></TradeRequestFinalizeForm>
  </v-card>
</div>
</template>
<script>
import TradeRequestFinalizeForm from '../components/TradeRequestFinalizeForm.vue';
export default {
  data() {
    return {};
  },
  components: {
    TradeRequestFinalizeForm,
  },
  methods: {
    
  },
};
</script>

<style></style>